import api from './api';
import { API_ROUTES } from '../config/api';
import { AggregateRequest, AggregateResponse } from '../types/inventory';
import apiRaw from './api';
import { API_ROUTES as ROUTES } from '../config/api';

export async function fetchInventoryAggregate(dbId: string, payload: AggregateRequest, signal?: AbortSignal): Promise<AggregateResponse> {
  const aggregateUrl = API_ROUTES.APPRO.BASE + API_ROUTES.APPRO.INVENTORY.AGGREGATE(dbId);
  try {
    const { data } = await api.post(aggregateUrl, payload, { signal });
    return data as AggregateResponse;
  } catch (error: any) {
    if (payload.snapshot && error?.response?.status === 404) {
      const { snapshot, ...legacyPayload } = payload;
      const { data } = await api.post(aggregateUrl, legacyPayload, { signal });
      return data as AggregateResponse;
    }
    throw error;
  }
}

export async function fetchInventoryAggregateSection<T = unknown>(
  dbId: string,
  snapshotId: string,
  section: string,
  signal?: AbortSignal
): Promise<T> {
  const { data } = await api.get(
    `${API_ROUTES.APPRO.BASE}/inventory/${dbId}/aggregate/snapshots/${snapshotId}/sections/${section}/`,
    { signal }
  );
  return data.data as T;
}

export async function fetchArticlesByIds(dbId: string, articleIds: string[], signal?: AbortSignal) {
  // Ensure trailing slash between base and path
  const base = ROUTES.DB_MANAGER.BASE.endsWith('/') ? ROUTES.DB_MANAGER.BASE.slice(0, -1) : ROUTES.DB_MANAGER.BASE;
  const { data } = await apiRaw.post(`${base}/databases/${dbId}/articles/by-ids/`, { article_ids: articleIds }, { signal });
  return data;
}


